import React from "react";
import ReactEcharts from "echarts-for-react";

// Function to calculate the linear regression (y = mx + b)
const getLinearTrend = (data) => {
  const n = data.length;
  const x = Array.from({ length: n }, (_, i) => i + 1); // Index as x-axis values
  const y = data;

  // Calculate the sum of x, y, x^2, and xy
  const sumX = x.reduce((acc, val) => acc + val, 0);
  const sumY = y.reduce((acc, val) => acc + val, 0);
  const sumXY = x.reduce((acc, val, idx) => acc + val * y[idx], 0);
  const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

  // Calculate the slope (m) and intercept (b)
  const m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const b = (sumY - m * sumX) / n;

  // Calculate the trend line values (y = mx + b) for each x
  const trendLine = x.map((val) => m * val + b);
  return trendLine;
};

const CreditorsDay = () => {
  const dates = [
    "Nov-19", "Dec-19", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20", "Jul-20", "Aug-20", "Sep-20", "Oct-20", 
    "Nov-20", "Dec-20", "Jan-21", "Feb-21", "Mar-21", "Apr-21", "May-21", "Jun-21", "Jul-21", "Aug-21", "Sep-21", "Oct-21", 
    "Nov-21", "Dec-21", "Jan-22", "Feb-22", "Mar-22", "Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22", "Sep-22", "Oct-22", 
    "Nov-22", "Dec-22", "Jan-23", "Feb-23", "Mar-23", "Apr-23", "May-23", "Jun-23", "Jul-23", "Aug-23", "Sep-23", "Oct-23", 
    "Nov-23", "Dec-23", "Jan-24", "Feb-24", "Mar-24", "Apr-24", "May-24", "Jun-24", "Jul-24", "Aug-24", "Sep-24", "Oct-24"
  ];

  const creditorsDaysOutstanding = [
    37.4, 32.7, 32.3, 30.5, 43.3, 40.4, 30.8, 32.2, 32.7, 27.2, 39.5, 40.1, 50.9, 61.6, 72.5, 74.6, 75.4, 76.0, 80.3, 
    83.3, 90.1, 86.4, 97.4, 96.5, 102.5, 91.7, 90.1, 96.9, 110.6, 115.2, 84.5, 126.3, 125.8, 123.1, 121.5, 100.8, 
    116.5, 118.6, 114.8, 115.5, 126.6, 122.5, 138.7, 130.5, 118.6, 75.8, 149.0, 89.2, 144.6, 154.5, 176.2, 184.0, 
    196.4, 190.0, 182.4, 124.3, 185.4, 155.6, 177.9, 181.6
  ];

  // Calculate the trend line for Creditors Days Outstanding
  const trendLine = getLinearTrend(creditorsDaysOutstanding);

  const option = {
    tooltip: { trigger: "axis" },
    legend: { data: ["Creditors Days Outstanding", "Trend Line"] },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        rotate: 45, // Rotate labels to fit better
        interval: 5, // Reduce label frequency to prevent overlap
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value} days", // Add "days" for clarity
      },
    },
    series: [
      {
        name: "Creditors Days Outstanding",
        type: "line",
        data: creditorsDaysOutstanding,
        smooth: true,
        lineStyle: { color: "blue" },
        markPoint: {
          data: [{ type: "max", name: "Max Value" }, { type: "min", name: "Min Value" }],
        },
      },
      {
        name: "Trend Line",
        type: "line",
        data: trendLine,
        smooth: true,
        lineStyle: { type: "dashed", color: "red" }, // Dashed line for the trend line
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: "500px" }} />;
};

export default CreditorsDay;
